import React from 'react'
import AccessInput from '../../components/Inputs/AccessInput'

const ManualAccess = () => {
    return (
        <div className='ps-4 pe-4 mt-4'>
            <AccessInput canScan={false} />
        </div>
    )
}

export default ManualAccess